<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">รายการสั่งซื้อสินค้าที่ถูกลบ</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายการสั่งซื้อสินค้าที่ถูกลบ
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <!-- desktop filter data table -->
          <v-col cols="12" v-if="!IpadProSize && !IpadSize && !MobileSize">
            <v-row>
              <v-col cols="12">
                <span>รหัสฝ่ายขาย
                  <v-autocomplete
                    class="pl-1 d-inline-block"
                    style="width: 180px;"
                    v-model="selectSalesId"
                    :items="salesIdListMenu"
                    outlined dense
                    item-text="emp_code"
                    placeholder="เลือกรหัสฝ่ายขาย"
                    no-data-text="ไม่พบรหัสฝ่ายขายที่ค้นหา"
                    return-object
                    hide-details
                    @click="getSalesDataList()"
                    @change="onChangeSales"
                  ></v-autocomplete>
                </span>
                <span class="pl-3">รหัสลูกค้า
                  <v-autocomplete
                    class="pl-1 d-inline-block"
                    style="width: 250px;"
                    :menu-props="{ maxWidth: IpadProSize || IpadSize ? '200px' : MobileSize ? '319px' : '250px' }"
                    v-model="selectCusId"
                    :items="cusIdListMenu"
                    outlined dense
                    item-text="cus_data"
                    placeholder="เลือกรหัสลูกค้า"
                    no-data-text="ไม่พบเลือกรหัสลูกค้าที่ค้นหา"
                    return-object
                    hide-details
                    @change="onChange"
                  ></v-autocomplete>
                </span>
              </v-col>
            </v-row>
          </v-col>
          <!-- ipad pro, ipad, mobile filter data table -->
          <v-col cols="12" v-else>
            <v-row>
              <v-col :cols="IpadProSize ? 4 : IpadSize ? 6 : 12">
                <span>รหัสฝ่ายขาย</span>
                <v-autocomplete
                  v-model="selectSalesId"
                  :items="salesIdListMenu"
                  outlined dense
                  item-text="emp_code"
                  placeholder="เลือกรหัสฝ่ายขาย"
                  no-data-text="ไม่พบรหัสฝ่ายขายที่ค้นหา"
                  return-object
                  hide-details
                  @click="getSalesDataList()"
                  @change="onChangeSales"
                ></v-autocomplete>
              </v-col>
              <v-col :cols="IpadProSize ? 4 : IpadSize ? 6 : 12">
                <span>รหัสลูกค้า
                  <v-autocomplete
                    v-model="selectCusId"
                    :items="cusIdListMenu"
                    :menu-props="{ maxWidth: IpadProSize || IpadSize ? '200px' : MobileSize ? '319px' : '250px' }"
                    outlined dense
                    item-text="cus_data"
                    placeholder="เลือกรหัสลูกค้า"
                    no-data-text="ไม่พบเลือกรหัสลูกค้าที่ค้นหา"
                    return-object
                    hide-details
                    @change="onChange"
                  ></v-autocomplete>
                </span>
              </v-col>
            </v-row>
          </v-col>
          <!-- search list order -->
          <v-col :cols="IpadProSize ? 9 : MobileSize || IpadSize ? 12 : 6" :class="!IpadProSize && !IpadSize && !MobileSize ? 'pl-0 mb-3 pt-6' : 'mb-3 pt-8'" v-if="disableTable === false">
            <v-text-field v-model="search" placeholder="ค้นหารหัสการสั่งซื้อที่ถูกลบ" outlined dense hide-details>
              <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
            </v-text-field>
          </v-col>
          <!-- count list order -->
          <v-col cols="12" class="pt-3" v-if="disableTable === false">
            <v-row dense>
              <v-col cols="12" class="pt-2">
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">รายการสั่งซื้อสินค้าที่ถูกลบทั้งหมด {{ showCountOrder }} รายการ</span>
              </v-col>
            </v-row>
          </v-col>
          <!-- table list order -->
          <v-col cols="12" v-if="disableTable === false" class="mt-5">
            <v-data-table
            :headers="shop === 'Sale Order' ? headersSaleOrder : headers"
            :items="deleteOrderList"
            :search="search"
            :page.sync="page"
            @pagination="countOrder"
            no-results-text="ไม่พบรายการสั่งซื้อสินค้าที่ถูกลบ"
            no-data-text="ไม่มีรายการสั่งซื้อสินค้าที่ถูกลบในตาราง"
            :footer-props="{'items-per-page-text':'จำนวนแถว'}"
            @update:items-per-page="itemsPerPage"
            :items-per-page="10"
            :class="shop === 'Sale Order' ? 'order-list-table' : 'order-list-table-gracz'"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                {{ formatDateTH(item.created_at) }}
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status === 'export'">
                  <v-chip small color="#ECF8EA" text-color="#1AB759">ดึงข้อมูลแล้ว</v-chip>
                </span>
                <span v-else-if="item.status === 'not_export'">
                  <v-chip small color="#FCF0DA" text-color="#FAAD14">รอการดึงข้อมูล</v-chip>
                </span>
              </template>
              <template v-slot:[`item.net_price`]="{ item }">
                {{ Number(item.net_price).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
              <template v-slot:[`item.transaction_status`]="{ item }">
                <v-chip small :color="getColor(item.transaction_status)" :text-color="getTextColor(item.transaction_status)">
                  {{ getStatus(item.transaction_status) }}
                </v-chip>
              </template>
              <template v-slot:[`item.manages`]="{ item }">
                <v-row>
                  <v-col>
                    <v-btn text rounded color="#27AB9C" :class="!MobileSize? 'px-2' : 'pa-0 ma-0'" small @click="deleteOrderDetail(item)">
                      <v-icon small>mdi-file-document-outline</v-icon>
                      <span>รายละเอียด</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
          <!-- empty data -->
          <v-col cols="12" v-else>
            <v-row justify="center" align-content="center">
              <v-col cols="12" md="12" align="center">
                <div class="my-5">
                  <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
                </div>
                <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายการสั่งซื้อสินค้าที่ถูกลบ</b></h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
import moment from 'moment'
export default {
  data () {
    return {
      showCountOrder: 0,
      pageCount: 5,
      page: 1,
      itemsPerPage: 10,
      deleteOrderList: [],
      disableTable: true,
      search: '',
      headers: [
        { text: 'วันที่', value: 'created_at', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสการสั่งซื้อ', value: 'order_number', filterable: true, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสลูกค้า', value: 'cus_code', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อลูกค้า', value: 'cus_name', filterable: false, sortable: false, width: '230px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาสุทธิ', value: 'net_price', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสฝ่ายขาย', value: 'sales_code', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'ผู้ลบ', value: 'delete_name', filterable: false, sortable: false, width: '190px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'status', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'manages', sortable: false, width: '120px', class: 'backgroundTable fontTable--text' }
      ],
      headersSaleOrder: [
        { text: 'วันที่', value: 'created_at', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสการสั่งซื้อ', value: 'order_number', filterable: true, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสลูกค้า', value: 'cus_code', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อลูกค้า', value: 'cus_name', filterable: false, sortable: false, width: '230px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาสุทธิ', value: 'net_price', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสฝ่ายขาย', value: 'sales_code', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'ผู้ลบ', value: 'delete_name', filterable: false, sortable: false, width: '190px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'status', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะการชำระเงิน', value: 'transaction_status', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'manages', sortable: false, width: '120px', class: 'backgroundTable fontTable--text' }
      ],
      salesIdListMenu: [],
      cusIdListMenu: [],
      statusListMenu: [
        { text: 'ทั้งหมด', status: 'all' },
        { text: 'ดึงข้อมูลแล้ว', status: 'export' },
        { text: 'รอการดึงข้อมูล', status: 'not_export' }
      ],
      selectSalesId: { emp_id: '', emp_code: 'ทั้งหมด' },
      selectCusId: { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' },
      userDetailSelling: '',
      customerData: '',
      shop: ''
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/DeletedOrderListMobile').catch(() => {})
      } else {
        this.$router.push('/Order/DeletedOrderList').catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        this.customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
      }
      this.checkShop()
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        if (this.shop === 'Sale Order') {
          this.getDataSaleOrder()
        } else {
          if (this.shop === 'Sale Order') {
            this.getDataSaleOrder()
          } else {
            this.getData()
          }
        }
      }
      this.getSalesDataList()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    if (this.shop === 'Sale Order') {
      this.$EventBus.$on('getDeleteOrderList', this.getDataSaleOrder)
    } else {
      this.$EventBus.$on('getDeleteOrderList', this.getData)
    }
    this.$on('hook:beforeDestroy', () => {
      this.$EventBus.$off('getDeleteOrderList')
    })
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    checkShop () {
      if (this.userDetailSelling.is_gracz === 'yes') {
        this.shop = 'Gracz'
      } else {
        if (this.userDetailSelling.is_rattana === 'yes') {
          this.shop = 'Rattana'
        } else {
          this.shop = 'Sale Order'
        }
      }
    },
    async getData () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        emp_id: '',
        emp_code: this.selectSalesId ? this.selectSalesId.emp_code === 'ทั้งหมด' ? '' : this.selectSalesId.emp_code : '',
        cus_id: this.selectCusId ? this.selectCusId.cus_id : '',
        page: this.page,
        count_item: this.itemsPerPage === -1 ? '' : this.itemsPerPage
      }
      await this.$store.dispatch('actionsGraczInactiveOrder', data)
      var response = await this.$store.state.ModuleGraczOrder.stateGraczInactiveOrder
      if (response.message === 'List inactive orders success') {
        this.$store.commit('closeLoader')
        this.deleteOrderList = response.data.orders
        if (this.deleteOrderList.length !== 0) {
          this.disableTable = false
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async getDataSaleOrder () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        emp_id: '',
        emp_code: this.selectSalesId ? this.selectSalesId.emp_code === 'ทั้งหมด' ? '' : this.selectSalesId.emp_code : '',
        cus_id: this.selectCusId ? this.selectCusId.cus_id : '',
        page: this.page,
        count_item: this.itemsPerPage === -1 ? '' : this.itemsPerPage
      }
      await this.$store.dispatch('actionsGraczInactiveOrderSaleOrder', data)
      var response = await this.$store.state.ModuleGraczOrder.stateGraczInactiveOrderSaleOrder
      if (response.message === 'List inactive orders success') {
        this.$store.commit('closeLoader')
        this.deleteOrderList = response.data.orders
        if (this.deleteOrderList.length !== 0) {
          this.disableTable = false
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async getSalesDataList () {
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        emp_code: this.selectSalesId.emp_code === 'ทั้งหมด' ? 'all' : this.selectSalesId.emp_code
      }
      await this.$store.dispatch('actionsGraczGetCustomerAndSalesList', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczGetCustomerAndSalesList
      if (response.message === 'Get list sales and customer success.') {
        // employee
        var all = { emp_id: '', emp_code: 'ทั้งหมด' }
        this.salesIdListMenu = response.data.list_employee
        this.salesIdListMenu.unshift(all)
        // customer
        var empAll = { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' }
        response.data.list_customer.forEach(e => {
          e.cus_data = e.cus_code + ' ' + e.cus_name
        })
        this.cusIdListMenu = response.data.list_customer
        this.cusIdListMenu.unshift(empAll)
      } else {
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    onChangeSalesMobile () {
      this.selectCusId = { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' }
      this.getSalesDataList()
    },
    onChangeSales () {
      this.selectCusId = { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' }
      this.getSalesDataList()
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        this.getData()
      }
    },
    onChange () {
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        this.getData()
      }
    },
    countOrder (pagination) {
      this.showCountOrder = pagination.itemsLength
      this.itemsPerPage = pagination.itemsPerPage
      this.page = pagination.page
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        this.getData()
      }
    },
    deleteOrderDetail (item) {
      var orderNumber = item.order_number
      if (this.MobileSize === false) {
        this.$router.push({ path: `/Order/DeletedOrderDetail?orderNumber=${orderNumber}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/Order/DeletedOrderDetailMobile?orderNumber=${orderNumber}` }).catch(() => {})
      }
    },
    formatDateTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var dateTH = moment(date).locale('TH').format('D MMMM ' + year)
      return dateTH
    },
    getColor (item) {
      if (item === 'Pending') return '#FCF0DA'
      else if (item === 'Not Paid') return '#FCF0DA'
      else if (item === 'Success') return '#F0F9EE'
      else if (item === 'Approve') return '#F0F9EE'
      else if (item === 'Fail') return '#F7D9D9'
      else if (item === 'Credit Term') return '#E5EFFF'
      else return '#F7D9D9'
    },
    getTextColor (item) {
      if (item === 'Pending') return '#E9A016'
      else if (item === 'Not Paid') return '#E9A016'
      else if (item === 'Success') return '#1AB759'
      else if (item === 'Approve') return '#1AB759'
      else if (item === 'Fail') return '#D1392B'
      else if (item === 'Credit Term') return '#1B5DD6'
      else return '#D1392B'
    },
    getStatus (item) {
      if (item === 'Pending') return 'รออนุมัติ'
      else if (item === 'Not Paid') return 'ยังไม่ชำระเงิน'
      else if (item === 'Success') return 'ชำระเงินสำเร็จ'
      else if (item === 'Approve') return 'วางบิล'
      else if (item === 'Fail') return 'ชำระเงินไม่สำเร็จ'
      else if (item === 'Credit Term') return 'ชำระเงินแบบเครดิตเทอม'
      else return 'ยกเลิกคำสั่งซื้อ'
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found.') {
        return ['ไม่พบพนักงาน', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else {
        return [msg, 'error']
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .order-list-table table {
    tbody {
      tr {
        td:nth-child(10) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(10) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
  ::v-deep .order-list-table-gracz table {
    tbody {
      tr {
        td:nth-child(9) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(9) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
</style>
